module.exports = __webpack_public_path__ + "static/media/alprints.e46ddda5.png";